export const DemoDataNotice = () => <div>Page is showing demo data.</div>
